import { viVN_TraceabilityResult } from './result';

export const viVN_Traceability = {
  ...viVN_TraceabilityResult
};
